import { all, takeEvery, put, call, select } from 'redux-saga/effects';
import Api from '../../helpers/api';
import actions from './actions';
import { sendRequest } from '../../helpers/saga';
import { getLoginApiUrl } from '../../settings';
import notifications from '../notifications/actions';
import { t } from '../../i18n';
import { IOrganization, ROLE_IDS } from './types';

const lookupApi = new Api(`${getLoginApiUrl()}/v1/lookup`);

// Only show Admin (Dash), Manager (Ondemand), and Agent (Agency) roles in org switcher
const ALLOWED_ROLE_IDS = Object.values(ROLE_IDS);

const filterOrganizationRoles = (organizations: IOrganization[]): IOrganization[] =>
  organizations
    .map(org => ({
      ...org,
      roles: org.roles.filter(role => ALLOWED_ROLE_IDS.includes(role.id)),
    }))
    .filter(org => org.roles.length > 0);

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function* fetchUserOrgs(): Generator<any, void, any> {
  const profile = yield select((state: any) => state.Auth.profile);
  const email = profile?.email;

  if (!email) {
    yield put(actions.fetchUserOrgsError('User email not found'));

    return;
  }

  const result = yield call(sendRequest, lookupApi.post, { email }, notifications.REQUEST_ERROR);

  if (result?.status === 200 && result?.data) {
    const responseData = result.data;

    yield put(
      actions.fetchUserOrgsSuccess({
        ...responseData,
        organizations: filterOrganizationRoles(responseData.organizations),
      }),
    );
  } else {
    yield put(actions.fetchUserOrgsError(result?.messages?.[0] || 'Failed to fetch user organizations'));
  }
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function* fetchUserOrgsError(action: any): Generator<any, void, any> {
  yield put(
    notifications.addNotification({
      headline: t('dash.common.notification.error_headline'),
      type: 'error',
      errorType: action.payload,
    }),
  );
}

export default function* rootSaga() {
  yield all([
    takeEvery(actions.FETCH_USER_ORGS_REQUEST, fetchUserOrgs),
    takeEvery(actions.FETCH_USER_ORGS_ERROR, fetchUserOrgsError),
  ]);
}
